import React, { useCallback, } from 'react';
import { connect, } from 'react-redux';
import Badge, { BadgeOrigin, } from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import Icon from 'common/components/Icon';
import { layout, components, } from 'styles';
import { CartShopStats, ShopCartItem, } from 'store/ducks/shopCart/types';
import { sumStatsInCartShopItems, } from 'store/ducks/shopCart/selectors';
import ShoppingCartPopper from './Popper';
import ShoppingCartList from './List';
import ShoppingCartHeader from './Header';
import ShoppingCartContent from './Content';

const badgeAnchorOrigin: BadgeOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
};

type Props = {
    itemsStats: CartShopStats,
    items: Array<ShopCartItem>,
};

const ShoppingCart: React.FC<Props> = ({
    itemsStats,
    items,
}) => {
    const badgeClasses = components.makeBadgeStyles();
    const cartShopClasses = layout.makeCartShopStyles();

    const {
        iconContainer,
    } = layout.makeHeaderStyles();

    const renderContentForPopper = useCallback(({ TransitionProps, setOpen, }) => (
        <Fade {...TransitionProps}
              timeout={350}>
            <ClickAwayListener onClickAway={() => setOpen(false)}
                               mouseEvent="onMouseDown"
                               touchEvent="onTouchStart">
                <Paper classes={{root: cartShopClasses.container,}}>
                    <ShoppingCartHeader amount={itemsStats.amount}
                                        setOpenPopper={setOpen}/>
                    {Boolean(itemsStats.amount) && <Box p={2}>
                        <ShoppingCartList items={items}/>
                        <Box mt={2}>
                            <ShoppingCartContent setOpen={setOpen} sumPrice={itemsStats.sumPrice}/>
                        </Box>
                    </Box>}
                </Paper>
            </ClickAwayListener>
        </Fade>
    ), [cartShopClasses.container, itemsStats.amount, itemsStats.sumPrice, items]);

    const popperChildren = useCallback(({ handleOpenStatus, }) => (
        <div className={iconContainer}>
            <Badge badgeContent={itemsStats.amount}
                   classes={badgeClasses}
                   overlap="circle"
                   max={999}
                   onClick={handleOpenStatus}
                   anchorOrigin={badgeAnchorOrigin}>
                <Icon.CartEmpty height={50} />
            </Badge>
        </div>
    ), [ iconContainer, itemsStats.amount, badgeClasses, badgeAnchorOrigin, ]);

    return (
        <ShoppingCartPopper renderContent={renderContentForPopper}>
            {popperChildren}
        </ShoppingCartPopper>
    );
};

type MappingType = {
    shopCart: Array<ShopCartItem>,
};

const mapStateToProps = (state: MappingType) => ({
    items: state.shopCart,
    itemsStats: sumStatsInCartShopItems(state),
});

export default connect(mapStateToProps)(ShoppingCart);
